<template>
  <div class="retransmission">
    <div class="selectionArea">
      <el-input v-model="parameter.key" placeholder="请输入关键字" style="margin-right: 10px; width:200px;" />
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      <el-button type="primary" icon="el-icon-circle-plus" style="position: absolute; right: 40px;" @click="dialogVisible = true">创建</el-button>
    </div>
    <div class="mainArea">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="account_id"
          label="账号id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="action_id"
          label="数据源id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          width="200"
        />
        <el-table-column
          prop="link_code"
          label="链接识别码"
          width="150"
          align="center"
        />
        <el-table-column
          prop="wechat_name"
          label="公众号名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="address"
          align="center"
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="copy(scope.row)">复制链接</el-button>
            <el-button type="primary" size="mini" @click="(currentlySelected = scope.row),(dialogVisible = true)">修改</el-button>
            <el-button type="warning" size="mini" @click="myDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <el-dialog
      :title="currentlySelected ? '修改链接配置' : '创建链接配置'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="650px"
      @closed="closePopup"
    >
      <Details v-if="dialogVisible" :current-item="currentlySelected" :url="url" @determine="determine" />
    </el-dialog>
  </div>
</template>

<script>
import Details from '@/views/taobaoLink/linkconfig/components/details.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { link_config, addlink_config, updatalink_config, dellink_config } from '@/api/taobaoLink.js'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      parameter: {
        key: null, // 公众号
        page: 1, // 当前页
        page_size: 10 // 每页数据量
      },
      dialogVisible: false,
      loading: false,
      tableData: {},
      currentlySelected: undefined, // 当前选中的项
      url: ''

    }
  },
  created() {
    this.getListData()
  },
  methods: {
    copy(data) {
      const newdata = data.url
      if (navigator.clipboard) {
        console.log(1)
        navigator.clipboard.writeText(newdata)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = newdata
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getListData()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getListData()
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.getListData()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.parameter.key = null
      this.getListData()
    },

    // 获取数据列表
    async getListData() {
      this.loading = true
      try {
        const data = await link_config(this.parameter)
        this.tableData = data.data
        this.url = data.data.domain
      } catch (err) {
        this.$message.error(err)
      }
      this.loading = false
    },

    // 关闭弹窗
    closePopup() {
      this.dialogVisible = false
      this.currentlySelected = undefined
    },

    // 确定
    async determine(form) {
      const bool = this.judge(form)
      if (bool) {
        return
      }
      form.content.forEach((item, i) => {
        console.log('item:', item)
        if (item.img !== null) {
          const regex = /user\/(.+)/
          console.log(item.img)
          const match = item.img.match(regex)
          // console.log('match:', match)
          const fileName = match ? match[1] : null
          // console.log('fileName:', fileName)
          const newImgUrl = fileName ? `user/${fileName}` : null
          item.img = newImgUrl
        }
      })
      try {
        if (form.id === null) {
          await addlink_config(form)
        } else {
          await updatalink_config({ ...form, id: this.currentlySelected.id })
        }
        this.$message.success(this.currentlySelected ? '更新成功' : '创建成功')
        this.getListData()
        this.closePopup()
      } catch (err) {
        // this.$message.error(err)
      }
    },

    // 判断
    judge(form) {
      let text = null
      if (!form.title) {
        text = '请选择标题'
      }
      if (!form.app_id) {
        text = '请选择公众号'
      }
      if (!form.account_id) {
        text = '请选择广告主'
      }
      if (!form.action_id) {
        text = '请选择数据源'
      }
      if (!form.link_code) {
        text = '请填写链接识别码'
      }
      form.content.forEach((item, index) => {
        if (!item.copy_code) {
          text = `第 ${index + 1} 个淘宝口令为空`
        }
        if (!item.img) {
          text = `第 ${index + 1} 个图片为空`
        }
      })
      text && this.$message.warning(text)
      return text
    },

    // 删除
    async myDelete(id) {
      console.log('id:', id)
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          await dellink_config(id)
          this.getListData()
          this.$message.success('删除成功')
        } catch (err) {
          this.$message.error(err)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.retransmission{
   width: 95%;
   margin: 0 auto;
   margin-top: 30px;
}
.selectionArea{
    display: flex;
}

.mainArea{
   margin-top: 30px;
}
</style>
